import { getCategoriasIva, createCategoriaIva, updateCategoriaIva, deleteCategoriaIva } from '../models/categoriaIvaModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchCategoriasIva(page, perPage) {
  try {
    const response = await getCategoriasIva(page, perPage);
    return {
      categoria_iva: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching categorías IVA:", error);
    Swal.fire('Error', 'No se pudieron cargar las categorías IVA', 'error');
    return null;
  }
}

export async function saveCategoriaIva(categoriaIva, currentCategoriaIvaId) {
  try {
    if (currentCategoriaIvaId) {
      await updateCategoriaIva(currentCategoriaIvaId, categoriaIva);
      toasts.add({
        title: 'Éxito',
        description: 'Categoría IVA guardada exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      await createCategoriaIva(categoriaIva);
      toasts.add({
        title: 'Éxito',
        description: 'Categoría IVA creada exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
  } catch (error) {
    console.error("Error saving categoría IVA:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar la categoría IVA',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

export async function removeCategoriaIva(id) {
  try {
    await deleteCategoriaIva(id);
    toasts.add({
      title: 'Éxito',
      description: 'Categoría IVA eliminada exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting categoría IVA:", error);
    Swal.fire('Error', 'No se pudo eliminar la categoría IVA', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'categoria_iva'
export function subscribeToCategoriasIva(searchQuery, handleSearch) {
  pb.collection('categoria_iva').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(); // Actualiza la lista manteniendo la página actual
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromCategoriasIva() {
  pb.collection('categoria_iva').unsubscribe('*');
}

export async function searchCategoriasIva(query, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('categoria_iva').getList(page, perPage, {
      filter: `descripcion ~ "${query}"`,
    });
    return {
      categoria_iva: response.items,
      totalRecords: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching categorías IVA:", error);
    Swal.fire('Error', 'No se pudieron buscar las categorías IVA', 'error');
    return null;
  }
}
